import { render } from "./ko.vue?vue&type=template&id=7e9e4135&scoped=true&ts=true"
import script from "./ko.vue?vue&type=script&lang=ts"
export * from "./ko.vue?vue&type=script&lang=ts"

import "./ko.vue?vue&type=style&index=0&id=7e9e4135&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e9e4135"]])

export default __exports__